module.exports = __webpack_public_path__ + "static/media/Assetman.23a8b744.jpg";